export interface CallSpamScores {
    scammer: number;
    telemarketing: number;
    market_research: number;
    opinion_poll: number;
    courier: number;
    safe: number;
    other: number;
}

export interface CallMetadata {
    spam_scores?: CallSpamScores;
}

export class Call {

    id!: string;

    from!: string;

    person!: string;

    tenant!: string;

    status!: string;

    date!: number;

    metadata!: CallMetadata | null;

    public GetDate(): Date {
        return new Date(this.date * 1000);
    }
}
